import * as actionTypes from '../actions/types';

const initialState = {
  isCollaborator: true,
  collaboratorJourneys: [],
  collaborators: [],
  isLoadingSearchedCollaborators: [],
  activeCollaborators: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_COLLABORATOR_JOURNEYS:
      return {
        ...state,
        collaboratorJourneys: action.collaboratorJourneys,
      };

    case actionTypes.SET_IS_COLLABORATOR:
      return {
        ...state,
        isCollaborator: action.isCollaborator,
      };
    case actionTypes.SET_COLLABORATORS:
      return {
        ...state,
        collaborators: [...action.collaborators],
      };
    case actionTypes.SET_SEARCHED_COLLABORATOR_LOADING:
      return {
        ...state,
        isLoadingSearchedCollaborators: action.isLoading,
      };
    case actionTypes.DELETE_COLLABORATOR:
      const { [action.id]: deleteCollaborator, ...collaborator } = state;
      return {
        ...collaborator,
      };

    case actionTypes.ADD_ACTIVE_COLLABORATOR:
    return {
      ...state,
      activeCollaborators:  action.activeCollaborators
    };

    default:
      return state;
  }
};
